import type { ReactNode } from "react";
import { useTheme } from "../hooks/useTheme";
import type { ThemeName } from "../context/ThemeContext";

const THEME_LABELS: Record<ThemeName, string> = {
  clean: "Clean",
  warm: "Warm",
  dark: "Dark",
  earth: "Earth",
  bold: "Bold",
};

export function ThemeSelector(): ReactNode {
  const { theme, setTheme, themes } = useTheme();

  return (
    <div className="theme-selector" role="radiogroup" aria-label="Theme">
      {themes.map((name) => (
        <button
          key={name}
          type="button"
          role="radio"
          aria-checked={theme === name}
          className={`theme-pill${theme === name ? " theme-pill-active" : ""}`}
          onClick={() => setTheme(name)}
        >
          {THEME_LABELS[name]}
        </button>
      ))}
    </div>
  );
}
